import { useAnalyticService } from '@b2ag/plugin-aladin-gtm'
import { useStore } from 'vuex'
import { computed } from 'vue'
import { getAppContext } from '@b2ag/micro-front-tools'
import { idfTrackingService } from '../idf-tracking'
import { analyticsViewItem } from '../utils/gtm-product-view-event'
import type { FullProduct } from '../services/shop.business'
import type { IAnalyticsProductDetailViewPayload } from '../domain/gtm-product-detail-view'
import type { CooperativeProduct } from '../services/product'
import type { ProductHit } from '@b2ag/search'

function productDetailView(newProduct: FullProduct<CooperativeProduct>) {
  const status = newProduct.isCooperativeProduct ?? false
  const category = newProduct.categories ? newProduct.categories[0]?.[1]?.label : null
  const unitPrice = +(newProduct.bestOffer?.unitPriceExcludingTaxes ?? 0)

  const payload: IAnalyticsProductDetailViewPayload = {
    ecommerce: {
      detail: {
        products: [
          {
            id: newProduct._id,
            name: newProduct.name,
            category: `${newProduct.family}|${category}`,
            variant: newProduct.variants[0]?.name,
            brand: newProduct.supplier,
            price: unitPrice,
            dimension15: status,
          },
        ],
      },
      productPage: {
        categoryLvl1: newProduct.family,
        categoryLvl2: category || null,
        categoryLvl3: newProduct.categories ? newProduct.categories[0]?.[2]?.label : null,
        status,
      },
    },
  }
  return payload
}

export function useProductAnalytics() {
  const store = useStore()
  const { isFrontAgri } = getAppContext()

  const currentProfile = computed(() => store.getters.currentProfile)
  const currentCooperativeId = computed(() => store.getters.currentCooperativeId)
  const currentCooperativeName = computed(() => store.getters.currentCooperativeName)
  const isAuthenticated = computed(() => store.getters.isAuthenticated)

  async function pushProductViewedIdfTracking(product) {
    const cooperativeId = +currentCooperativeId.value
    const categorie0 = product.categories ? product.categories[0][0].label : null
    const categorie1 = product.categories ? product.categories[0][1].label : null
    const trackingProduct = {
      id: product._id,
      level_categorie_0: categorie0,
      level_categorie_1: categorie1,
    }
    await idfTrackingService.trackProductViewed(
      currentProfile.value.membershipNumber,
      cooperativeId,
      currentCooperativeName.value,
      trackingProduct,
    )
  }

  function sendProductViewedToAnalytics(
    product: FullProduct<CooperativeProduct>,
    algoliaProduct: FullProduct<ProductHit>,
  ) {
    const ecomDetailPayload = productDetailView(product)
    useAnalyticService().trackEvent('ecomDetail', ecomDetailPayload)
    useAnalyticService().resetEcommerce()
    useAnalyticService().trackEvent('view_item', analyticsViewItem(product, algoliaProduct))
    if (isAuthenticated.value && isFrontAgri) {
      pushProductViewedIdfTracking(product)
    }
  }

  return { sendProductViewedToAnalytics }
}
